import { DepletionStatusContent } from "@/components/admin/depletion/DepletionStatusContent";

export const DepletionStatusTab = () => {
  return <DepletionStatusContent />;
};
